/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef } from 'react';
import './Player.scss';

export const SoundPlayer = ({ play, pause, voicemailAudio }) => {
  const [isPlay, setIsPlay] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const timerIdRef = useRef(null);
  const playerLine = useRef(null);

  const handlePlay = () => {
    setIsPlay(true);
    play(currentTime);
  };

  const handlePause = () => {
    setIsPlay(false);
    pause();
  };

  const updateCurrent = () => {
    setCurrentTime(voicemailAudio.currentTime.toFixed(1));
  };

  useEffect(() => {
    updateCurrent();
  }, []);

  useEffect(() => {
    if (isPlay) {
      const timerId = setInterval(updateCurrent, 20);
      timerIdRef.current = timerId;
    }

    return () => {
      clearInterval(timerIdRef.current);
    };
  }, [isPlay]);

  const currentPlace = (currentTime * 100) / voicemailAudio.duration.toFixed(1);

  const handleSoundMove = (e) => {
    const leftContainer = playerLine.current.offsetLeft;
    const newCurrentPosition =
      ((e.clientX - leftContainer) * 100) / playerLine.current.offsetWidth;
    const newCurrentDuration =
      (newCurrentPosition * voicemailAudio.duration.toFixed(1)) / 100;
    if (isPlay) {
      setCurrentTime(newCurrentDuration);
      voicemailAudio.currentTime = newCurrentDuration;
    } else {
      pause();
      setCurrentTime(newCurrentDuration);
      voicemailAudio.currentTime = newCurrentDuration;
      setIsPlay(true);
      play();
    }
  };

  return (
    <div className="player-container">
      {isPlay ? (
        <>
          <button onClick={handlePause} className="controls">
            <svg
              width="17"
              height="19"
              viewBox="0 0 17 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.74609 0.5C1.7796 0.5 0.996094 1.2835 0.996094 2.25V16.75C0.996094 17.7165 1.7796 18.5 2.74609 18.5H6.24609C7.21259 18.5 7.99609 17.7165 7.99609 16.75V2.25C7.99609 1.2835 7.21259 0.5 6.24609 0.5H2.74609ZM11.7461 0.5C10.7796 0.5 9.99609 1.2835 9.99609 2.25V16.75C9.99609 17.7165 10.7796 18.5 11.7461 18.5H15.2461C16.2126 18.5 16.9961 17.7165 16.9961 16.75V2.25C16.9961 1.2835 16.2126 0.5 15.2461 0.5H11.7461Z"
                fill="#fff"
              />
            </svg>
          </button>
          <span className="text">Pause</span>
        </>
      ) : (
        <>
          <button onClick={handlePlay} className="controls">
            <svg
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.85563 6.65498C8.02249 6.19354 7 6.79608 7 7.74847V13.2516C7 14.204 8.0225 14.8065 8.85563 14.3451L14.6134 11.1561C14.852 11.024 15 10.7727 15 10.5C15 10.2273 14.852 9.97607 14.6134 9.84393L8.85563 6.65498ZM10 0.5C4.47715 0.5 0 4.97715 0 10.5C0 16.0228 4.47715 20.5 10 20.5C15.5228 20.5 20 16.0228 20 10.5C20 4.97715 15.5228 0.5 10 0.5ZM1.5 10.5C1.5 5.80558 5.30558 2 10 2C14.6944 2 18.5 5.80558 18.5 10.5C18.5 15.1944 14.6944 19 10 19C5.30558 19 1.5 15.1944 1.5 10.5Z"
                fill="white"
              />
            </svg>
          </button>
          <span className="text">Listen to voicemail</span>
        </>
      )}

      <div
        className="progressbar-wrap"
        onClick={handleSoundMove}
        ref={playerLine}
      >
        <div className="progressbar">
          <div className="played" style={{ width: `${currentPlace}%` }}></div>
          <div className="dot" style={{ left: `${currentPlace}%` }}></div>
        </div>
      </div>

      <div className="bottom-info">
        <span>{currentTime}</span>
        {Boolean(voicemailAudio.duration) && (
          <span>{voicemailAudio.duration.toFixed(1)}</span>
        )}
      </div>
    </div>
  );
};
